<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <div v-if="loading">
          <loading></loading>
        </div>
        <v-flex md6>
          <grafica-captura
            v-for="(graf, indexChart) in pruebas"
            :key="indexChart"
            :res="res[indexChart]"
            :titulo="titleGrafica[indexChart]"
            :titleIn="titleTest[indexChart]"
          ></grafica-captura>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import GridEvolucionGrafica from "@/modules/captura/views/seguimiento/evolucionGrafica/GridEvolucionGrafica.vue";
import Loading from "@/views/ui/Loading.vue";
import GraficaCaptura from "@/modules/captura/views/seguimiento/evolucionGrafica/GraficaCaptura.vue";

export default {
  name: "scan-tab",

  components: {
    GridEvolucionGrafica,
    Loading,
    GraficaCaptura,
  },

  props: {},

  data() {
    return {
      loading: false,
      proveedor: {},
      rowsTable: [20],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      gridDocumento: 20,
      indexChart: 0,
      res: [],
      titleGrafica: [],
      titleTest: [],
      pruebas: [],
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.loadDataCaptura();
  },

  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },

    async loadDataCaptura() {
      this.loading = true;
      this.pruebas = [];
      this.pruebas = await this.loadCaptura();
      if (this.pruebas.length > 0) {
        this.pruebas.forEach((m) => {
          let data = [];
          this.titleGrafica[this.indexChart] =
            "Nivel: " + m.s_nivel + " / Captura";

          data.push(
            {
              value: m.porc_capturado.toFixed(2),
              name: "Capturado: " + m.porc_capturado.toFixed(2) + " %",
            },
            {
              value: m.porc_pendiente.toFixed(2),
              name: "Pendiente Captura: " + m.porc_pendiente.toFixed(2) + " %",
            }
          );

          this.res[this.indexChart] = data;
          this.indexChart += 1;
        });
      } else {
        this.showAlert = true;
        this.res = [];
        this.indexChart = 0;
        this.titleGrafica = [];
      }
      this.loading = false;
    },
    async loadCaptura() {
      return await axios
        .get("/seguimiento/captura/grafica/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>
